const createScenario = {
  title: 'Build a Scenario',

  form: {
    header: {
      title: 'Hello {{firstName}},',
    },
    fields: {
      sitePlaceHolder: 'What is the name of your operation?',
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Which scenario would you like to run with Moovex?',
        instructions: 'Please, check the field that describes your zone of business the most.',
      },
    },

    button: 'I WANT TO BUILD A SCENARIO',
  },
};

export default createScenario;
